import { render } from "./ProductHeader.vue?vue&type=template&id=14d48602"
import script from "./ProductHeader.vue?vue&type=script&lang=js"
export * from "./ProductHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__